/**
 * matchMedia wrapper with subscribe — replaces useMediaQuery hook.
 */

export type MediaQuerySubscription = {
  matches: boolean;
  subscribe: (cb: (matches: boolean) => void) => void;
  destroy: () => void;
};

export function createMediaQuery(query: string): MediaQuerySubscription {
  const mql = window.matchMedia(query);
  let currentMatches = mql.matches;
  const listeners: Set<(matches: boolean) => void> = new Set();

  const handler = (e: MediaQueryListEvent) => {
    currentMatches = e.matches;
    listeners.forEach((cb) => cb(currentMatches));
  };

  mql.addEventListener("change", handler);

  return {
    get matches() {
      return currentMatches;
    },
    subscribe(cb: (matches: boolean) => void) {
      listeners.add(cb);
    },
    destroy() {
      mql.removeEventListener("change", handler);
      listeners.clear();
    },
  };
}
